import React, { useEffect, useState } from "react";
import FormField from "../../../components/common/FormField";
import {
  CREATE_INVOICE_FORM_ELEMENTS,
  INVOICE_TYPES_OPTIONS,
  invoiceFormElements,
  invoiceValidateForm,
} from "./invoiceUntils";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
interface InvoiceFormProps {
  formData: any;
  setFormData: any;
  isFormReadyOnly: any;
  isNewInvoice?: boolean; // Optional prop to indicate if it's a new invoice
}
const InvoiceForm: React.FC<InvoiceFormProps> = (props) => {
  const { formData, setFormData, isFormReadyOnly, isNewInvoice } = props;

  const [errors, setErrors] = useState<any>({});
  const { userProfile } = useSelector((state: any) => state?.user);
  const { leadDetails } = useSelector((state: any) => state.lead);
  const { invoiceTypes } = useSelector((state: any) => state?.quickBook);
  const { payments = [] } = useSelector((state: any) => state?.payment);
  const [isProfessionalSection, setIsProfessionalSection] = useState(
    userProfile?.features?.includes("Professional Financial") || false // Safe fallback
  );

  useEffect(() => {
    setIsProfessionalSection(
      userProfile?.features?.includes("Professional Financial") || false
    ); // Sync profile changes
  }, [userProfile]);

  // if professional → use Redux invoiceTypes, else → dummy
  const dynamicInvoiceTypes =
    isProfessionalSection && invoiceTypes?.length
      ? invoiceTypes.map((item: any) => ({
          id: item.id ?? item.name,
          name: item.name,
          tooltip: item.description || item.tooltip || "", // << ADD TOOLTIP
        }))
      : INVOICE_TYPES_OPTIONS;

  const selectedInvoiceTypeValue = (() => {
    const currentValue = formData?.invoice_type_id || formData?.invoice_type;
    const selectedType = dynamicInvoiceTypes.find(
      (type: any) =>
        type?.id === currentValue ||
        type?.name === currentValue ||
        String(type?.id).toLowerCase() === String(currentValue).toLowerCase() ||
        String(type?.name).toLowerCase() === String(currentValue).toLowerCase(),
    );

    return selectedType?.id || "";
  })();

  // -----------------------------
  // 🔹 STEP 2: Choose form structure
  // -----------------------------
  const formElements =
    isNewInvoice &&
    formData?.invoice_type !== "deposit" &&
    formData?.category !== "final"
      ? CREATE_INVOICE_FORM_ELEMENTS
      : invoiceFormElements;

  // -----------------------------
  // 🔹 STEP 3: Inject dynamic options into invoice_type field
  // -----------------------------
  const formElementsWithDynamicOptions = formElements.map((field) => {
    if (field.id === "invoice_type") {
      return { ...field, options: dynamicInvoiceTypes };
    }
    return field;
  });

  const onChangeAction = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = event.target;
    // Handle nested address fields differently
    if (id.startsWith("address.")) {
      const field = id.split(".")[1]; // e.g. 'street', 'town', etc.
      setFormData((prev: any) => ({
        ...prev,
        address: {
          ...prev.address,
          [field]: value,
        },
      }));
      // Validate nested address changes
      const updatedData = {
        ...formData,
        address: {
          ...formData.address,
          [field]: value,
        },
      };
      const validationResults = invoiceValidateForm(updatedData);
      setErrors(validationResults.localError);
    } else if (id === "invoice_type") {
      const selectedType = dynamicInvoiceTypes.find(
        (type: any) => type.name === value || type.id === value,
      );

      const updatedFormData = {
        ...formData,
        invoice_type: selectedType?.name || value,
        invoice_type_id: selectedType?.id || null,
      };
      setFormData(updatedFormData);

      // Clear address fields if invoice_type is 'deposit' or 'final'
    } else {
      const updatedFormData = {
        ...formData,
        [id]: value,
      };
      setFormData(updatedFormData);
      // Validate after updating form data
      const validationResults = invoiceValidateForm(updatedFormData);
      setErrors(validationResults.localError);
    }
  };

  console.log("formData-125",formData);

  return (
    <Grid
      container
      spacing={0.5}
      sx={{
        mt: 1,
        backgroundColor: "#E5F4F1",
        border: "1px solid #CFCFCF",
        borderRadius: "5px",
        padding: "10px 6px",
      }}
    >
      {formElementsWithDynamicOptions?.map((field, i) => {
         // --------------------------------------------------
        // Contract No
        // Show only when both contract_id and contract_no exist
        // --------------------------------------------------
        if (
          field.id === "contract_no" &&
          !(formData?.contract_id && formData?.contract_no)
        ) {
          return null;
        }
        // --------------------------------------------------
        // Address
        // --------------------------------------------------
        if (field.id === "address") {
          if (
            isNewInvoice &&
            formData?.invoice_type !== "deposit" &&
            formData?.category !== "final"
          ) {
            // Editable address fields for new invoice
            const addressFields = [
              {
                id: "street",
                label: "Street",
                md: 6,
                type: "text",
                isFormReadyOnly: true,
              },
              // { id: "", label: "", type: "title", md: 0.5 },
              {
                id: "town",
                label: "Town",
                md: 3,
                type: "text",
                isFormReadyOnly: true,
              },
              { id: "county", label: "County", md: 3, type: "text",isFormReadyOnly: true },
              // { id: "", label: "", type: "title", md: 0.5 },
              { id: "country", label: "Country", md: 3, type: "text", isFormReadyOnly: true },
              // { id: "", label: "", type: "title", md: 0.5 },
              { id: "postcode", label: "Postcode", md: 3, type: "text", isFormReadyOnly: true },
            ];

            return addressFields.map(({ id, label, md, type }) => (
              <FormField
                key={id}
                id={`address.${id}`} // Dot notation for nested field
                label={label}
                type={type}
                value={formData?.address?.[id] || ""}
                onChange={onChangeAction}
                error={!!errors?.address?.[id]}
                disabled={isFormReadyOnly}
                isNonMarginTop
                md={md}
                inSingleGridForm={true}
                InputProps={{
                  ...(field?.inputProps || {}),
                  // disabled: isFormReadyOnly || field?.editReadOnly,
                  sx: type === "text" ? { height: "36px" } : { padding: "4px" },
                }}
              />
            ));
          } else {
            // Read-only full address string for existing invoice
            const addr = formData?.address || {};
            const formattedAddress =
              typeof addr === "string"
                ? addr
                : `${addr.street || ""}${addr.street ? ", " : ""}${
                    addr.town || ""
                  }${addr.town ? ", " : ""}${addr.county || ""}${
                    addr.county ? ", " : ""
                  }${addr.country || ""}${addr.country ? ", " : ""}${
                    addr.postcode || ""
                  }`;

            return (
              <FormField
                key={`address-readonly-${i}`}
                id="address"
                label={field.label}
                value={formattedAddress}
                type="text"
                disabled
                multiline
                isNonMarginTop
                md={field.md}
                inSingleGridForm={true}
                InputProps={{
                  sx: { padding: "4px" },
                }}
                error={false}
              />
            );
          }
        }
        // Default handling for all other fields
        return (
          <FormField
            key={i}
            onPaste={(e: any) => field?.id ==='description' || field?.id === 'address' ? '' : e.preventDefault()}
            onKeyDown={(event: any) => {
                if (field?.id === "description" || field?.id === "address") return;
              if (
                event.keyCode === 8 ||
                event.keyCode === 9 ||
                event.keyCode === 37 ||
                event.keyCode === 38 ||
                event.keyCode === 39 ||
                event.keyCode === 40 ||
                event.keyCode === 18 ||
                event.keyCode === 17 ||
                event.ctrlKey
              )
                return;

              if (
                field?.patternAllowed &&
                !field?.patternAllowed.test(event.key)
              ) {
                event.preventDefault();
              } else if (
                field?.patternAllowed &&
                !field?.patternAllowed.test(event.target.value + event.key)
              ) {
                event.preventDefault();
              }
            }}
            {...{
              ...field,
              ...(field.id === "due_date" && {
                minDate: formData?.invoice_date || formData?.created_at,
              }),

              value:
                field.id === "invoice_type" &&
                isNewInvoice
                  ? selectedInvoiceTypeValue
                  : field?.id === "address"
                  ? `${formData?.street || ""} ${formData?.town || ""} ${
                      formData?.county || ""
                    } ${formData?.country || ""} ${formData?.postcode || ""}` // Concatenate street and town
                  // : field?.id === "created_at"
                  // ? dayjs(formData && formData[field?.id]).format(
                  //     userProfile?.dateFormat
                  //       ? userProfile?.dateFormat
                  //       : "DD/MM/YYYY"
                  //   )
                  : formData
                  ? formData[field?.id]
                  : "",

              variant: "outlined",
              onChange: onChangeAction,
              // onBlur: onBlurAction,
              isNonMarginTop: true,
              inSingleGridForm: true,
              // disableBackground: "#eeecef",
              multiline: true,
              disabled:
                isFormReadyOnly ||
                field?.editReadOnly ||
                (field?.id === "created_at" && payments.length > 0) ||
                (formData?.invoice_type === "deposit" &&
                  leadDetails?.lead?.status === "JOB"),
              InputProps: {
                ...(field?.inputProps && field?.inputProps),
                ...{ disabled: isFormReadyOnly || field?.editReadOnly },
                sx:
                  field?.type === "text" || field?.type === "password"
                    ? { height: "36px" }
                    : { padding: "4px" },
              },

              error: !!errors?.[field.id],
              // helperText: errors?.[field.id] || '',
            }}
          />
        );
      })}
    </Grid>
  );
};

export default InvoiceForm;
